<template>
  <container>
    <div style="width: 1000px; height: 800px">
      <map-bs marker="/standalone-html-pages/sound-of-religion/data.htm" />
    </div>
  </container>
</template>

<script lang="ts" setup>
defineBlokkliFragment({
  name: 'sound_of_religion',
  label: 'Sound of religion',
})

const config = useRuntimeConfig()

useScript({
  src: `https://api.geo.bs.ch/mapbs-api/v1/mapbs-api.js?apikey=${config.public.mapbsApiKey}`,
  type: 'module',
  crossorigin: 'anonymous',
})
</script>
